export default __webpack_public_path__ + "static/media/resume.6b14a4fd.pdf";